export function isMoney(a) {
  return 'amount' in a;
}